import React, { Component } from "react";
import axios from "../../api-axios";
import "./UploadFiles.css";
import UserInfo from "../../UserInfo";
import notify from "devextreme/ui/notify";
import sendPgdasd from "../../sendPgdasdService";
import { LoadIndicator } from "devextreme-react";


export default class UploadFiles extends Component {
  constructor(props) {
    super(props);

    this.state = {
      files: [],
      dropZoneTitle: "Arraste os arquivos aqui...",
    };

    this.onFileChange = this.onFileChange.bind(this);
    this.onFileUpload = this.onFileUpload.bind(this);
    this.onDropHandler = this.onDropHandler.bind(this);
    this.onDragOverHandler = this.onDragOverHandler.bind(this);
  }

  obterLengenda = (tipo) => {
    if (tipo == "pgdasd") {
      return "PGDAS-D";
    }
    else if (tipo == "daf607") {
      return "DAF-607";
    }
    else if (tipo == "pagsimples") {
      return "DE PAGAMENTO DO SIMPLES NACIONAL";
    }
  }

  onFileChange = (event) => {
    this.setState({ files: event.target.files });
  };

  onFileUpload = async () => {

    let files = Object.values(this.state.files);

    const resultadosEnvio = [];

    // for (let i = 0; i < files.length; i++) {

    //   // sendPgdasd("ibiapina.ce", files[i], resultado => resultadosEnvio.push(resultado));



    // }

    try {

      var requestUrls = {
        tipoArquivo: this.props.match.params.tipo,
        prefeituraId: UserInfo.getPrefeitura(),
        nomeArquivos: files.map(f => f.name)
      };

      this.setState({ carregando: true, msgCarregando: "Preparando envio..." });

      var urls = await axios.post("/receberarquivos/gerar_urls_assinadas", requestUrls);

      this.setState({ carregando: true, msgCarregando: "Enviando..." });

      const todosEnvios = urls.data.map(x => {
        const file = files.filter(f => f.name == x.nomeArquivo)[0];
        fetch(x.url, { method: 'PUT', body: file });
      });

      this.setState({ carregando: false, msgCarregando: "" });
    }
    catch (error) {
      console.log(error.message);
      console.log(error);
      notify(error.message, "error");
    }
    finally {
      this.setState({ carregando: false, msgCarregando: "" });
    }
  };

  fileData = () => {
    if (this.state.files.length > 0) {
      let filesList = Object.values(this.state.files);
      return (
        <div>
          <h2>Detalhes:</h2>
          <br />
          {filesList.map((file, index) => {
            return (
              <div className={"file-list-div"} key={index}>
                <p>Nome do Arquivo: {file.name}</p>
                <p>Tipo do Arquivo: {file.type}</p>
              </div>
            );
          })}
        </div>
      );
    }
  };

  onDropHandler = (e) => {
    e.preventDefault();
    if (e.dataTransfer.items) {
      let files = [];
      for (var i = 0; i < e.dataTransfer.items.length; i++) {
        if (e.dataTransfer.items[i].kind === "file") {
          let file = e.dataTransfer.items[i].getAsFile();
          files.push(file);
        }
      }
      this.setState({
        files: files,
        dropZoneTitle: "Arraste os arquivos aqui...",
      });
    } else {
      let files = [];
      for (var i = 0; i < e.dataTransfer.files.length; i++) {
        files.push(e.dataTransfer.files[i]);
      }
      this.setState({
        files: files,
        dropZoneTitle: "Arraste os arquivos aqui...",
      });
    }
  };

  onDragOverHandler = (e) => {
    e.preventDefault();
    if (this.state.dropZoneTitle !== "Solte os arquivos...") {
      this.setState({ dropZoneTitle: "Solte os arquivos..." });
    }
  };

  render() {

    const legenda = this.obterLengenda(this.props.match.params.tipo);

    if (this.state.carregando) {
      return (
        <div className={"content-block dx-card responsive-paddings"} style={{ textAlign: "center", padding: "100px" }}>
          <LoadIndicator height={40} />
          <h3>{this.state.msgCarregando}</h3>
        </div>
      );
    }

    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <h3 style={{ textAlign: "center" }}>ENVIAR ARQUIVO {legenda}</h3>
        <div
          className="upload-files-input-div"
          onDrop={this.onDropHandler}
          onDragOver={this.onDragOverHandler}
          onDragLeave={() =>
            this.setState({ dropZoneTitle: "Arraste os arquivos aqui..." })
          }
        >
          <label htmlFor="file-upload" className="custom-file-upload">
            {/* <MdFileUpload size={60} color={"#999999"} /> */}
            <div className="drag-area-title">{this.state.dropZoneTitle}</div>
            <p style={{ fontSize: "25px", fontWeight: "bold" }}>ou</p>
            <div className="drag-area-combo-box-files">
              <div className="drag-area-box">
                <p>Escolha os arquivos</p>
              </div>
              <p style={{ marginLeft: "15px", fontSize: "15px" }}>
                {this.state.files.length} arquivos selecionados
              </p>
            </div>
          </label>
          <input
            id="file-upload"
            type="file"
            multiple={true}
            onChange={this.onFileChange}
          />

          {/* <button className="with-hover" onClick={this.onFileUpload}>Enviar</button> */}
          <button onClick={this.onFileUpload}>Enviar</button>
          {this.fileData()}
        </div>
      </div>
    );
  }
}
